import { AssetTypes } from "@zapier/utils";
import { MoveModalInner } from "./core/MoveModalInner";
import {
  useEmitFolderActionEvent,
  FolderActionInteractionOption,
} from "../../../events/";
import { MoveModalProps, OnMoveOptions } from "./core/types";
import { useMoveAssetActions } from "./useMoveAssetActions";

export function MoveAssetModal({
  assetType,
  assetIds,
  assetsAreShared = false,
  assetParentId,
  assetTitle,
  isOpen,
  isAssetOwnedByUser = false,
  onSettled,
  setIsOpen,
}: MoveModalProps) {
  const { moveAssetsToFolderWithToasts } = useMoveAssetActions({
    assetTitle,
    assetParentId,
    onSettled,
  });
  const { emit } = useEmitFolderActionEvent();

  const handleMoveAssetsToFolder = ({
    selectedFolderId,
    selectedFolderName,
  }: OnMoveOptions) => {
    if (!selectedFolderId) {
      return;
    }

    if (!assetIds || assetIds?.length === 0) {
      return;
    }
    moveAssetsToFolderWithToasts({
      assetIds,
      selectedFolderId,
      selectedFolderName,
    });
    emit({
      optionSelected: FolderActionInteractionOption.MoveFolder,
    });
    setIsOpen(false);
  };

  // Do not display the modal if isOpen==false
  if (!isOpen) {
    return;
  }

  return (
    <MoveModalInner
      assetType={assetType || AssetTypes.Zap}
      assetIds={assetIds}
      assetsAreShared={assetsAreShared}
      assetParentId={assetParentId}
      assetTitle={assetTitle}
      isAssetOwnedByUser={isAssetOwnedByUser}
      onMove={handleMoveAssetsToFolder}
      setIsOpen={setIsOpen}
    />
  );
}
